import React, { useEffect, useState } from "react";

const useLogic = (openBackdrop) => {
  const [backdrop, setBackdrop] = useState(null);
  useEffect(() => {
    setBackdrop(openBackdrop);
  }, [openBackdrop]);

  return { backdrop, setBackdrop };
};

export default useLogic;
